module.exports = {
      id: "Play_Video-usage",
      viewBox: "-298.474 310.883 86 60.23",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Play_Video-usage",
      toString: function () {
        return this.url;
      }
    }